import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  var [scrolled, setScrolled] = useState(false);
  var [menuOpen, setMenuOpen] = useState(false);
  var location = useLocation();
  var isHome = location.pathname === "/";

  useEffect(function() {
    function onScroll(){ setScrolled(window.scrollY > 60); }
    window.addEventListener("scroll", onScroll);
    return function(){ window.removeEventListener("scroll", onScroll); };
  },[]);

  useEffect(function() {
    setMenuOpen(false);
  }, [location.pathname]);

  function handleBackdropClick(e) {
    if (e.target.classList.contains("nav-backdrop")) {
      setMenuOpen(false);
    }
  }

  var cls = isHome ? (scrolled ? "navbar solid" : "navbar transparent") : "navbar solid";

  return (
    <>
      <nav className={cls}>
        <div className="nav-inner">
          <Link to="/">
            <img
              src="/bookalblogo.png"
              alt="BookingAlb"
              style={{width:"160px",height:"auto",display:"block"}}
            />
          </Link>
          <div className="desktop-links">
            <Link to="/stays">Stays</Link>
            <Link to="/autos">Autos</Link>
            <Link to="/for-owners">For Owners</Link>
            <Link to="/about">About</Link>
            <Link to="/contact" className="nav-cta">Contact</Link>
          </div>
          <button className="hamburger" onClick={()=>setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span/><span/><span/>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="nav-backdrop" onClick={handleBackdropClick}>
          <div className="nav-mobile-menu">
            <button className="nav-close" onClick={() => setMenuOpen(false)}>✕</button>
            <Link to="/stays" onClick={() => setMenuOpen(false)}>Stays</Link>
            <Link to="/autos" onClick={() => setMenuOpen(false)}>Autos</Link>
            <Link to="/for-owners" onClick={() => setMenuOpen(false)}>For Owners</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
            <Link to="/contact" className="nav-mobile-cta" onClick={() => setMenuOpen(false)}>Contact</Link>
          </div>
        </div>
      )}
    </>
  );
}